export default {
  name: 'NumberBox',
  props: {
    heading: String,
    value: String,
    inactive: Boolean
  }
};
